import { CelebrationType } from './types';
import { ForcedPrivateCheerSettings } from './usePrivateCheerSettings';

// Celebration "type" is the predefined-image id. Birthday-widget cheers use
// 'happyBirthday'; anniversary-widget cheers use 'congrats'.
export const BIRTHDAY_CELEBRATION_TYPE: CelebrationType = 'happyBirthday';
export const CONGRATS_CELEBRATION_TYPE: CelebrationType = 'congrats';

export const noForcedPrivateCheers: ForcedPrivateCheerSettings = {
  forceBirthdayCheersPrivate: false,
  forceCongratsCheersPrivate: false,
};

export const isCheerTypeForcedPrivate = (
  type: CelebrationType | string | null | undefined,
  settings: ForcedPrivateCheerSettings,
): boolean => {
  if (type === BIRTHDAY_CELEBRATION_TYPE) {
    return settings.forceBirthdayCheersPrivate;
  }
  if (type === CONGRATS_CELEBRATION_TYPE) {
    return settings.forceCongratsCheersPrivate;
  }
  return false;
};
